import React from "react";
import './voices_for_palestine.css'
import { PageIntro, DocSection, DocContent } from '../Templates'

const VoicesForPalestine = () => {
    return (
        <React.Fragment>
            <h1>Voices For Palestine</h1>
            <PageIntro>Voices around the world stand in solidarity with Palestine. We’ve compiled a list of organizations to amplify them.</PageIntro>
            <DocContent>
                <DocSection title="The BDS Movement">
                    <p className="vfp">Palestinian people have put out a call to the world to engage in a targeted Boycott, Divest and Sanctions campaign via the <a href="https://bdsmovement.net/Act-Now-Against-These-Companies-Profiting-From-Genocide">BDS Movement</a>.</p>
                    <div className="vfp-image">
                        <img className="vfp-image" alt="bds target brands" src="img/letters_of_lamentation/bds-10-2025.png" />
                    </div>
                    <p className="vfp">Did you know there are anti-BDS laws in Utah and multiple states in the USA? The <a href="https://justvision.org/boycott">'Boycott' documentary</a> by Just Vision is a great way to learn about them.</p>
                </DocSection>
                <DocSection title="Palestine Academy">
                    <p className="vfp"><a href="https://www.thepalestineacademy.com/">Palestine Academy</a> directs you to media that reclaims the narrative from the Israeli propaganda machine.</p>
                </DocSection>
                <DocSection title="Decolonize Palestine">
                    <p className="vfp"><a href="https://decolonizepalestine.com/">Decolonize Palestine</a> is an educational hub to learn about Palestine. It was founded by two Palestinians living in Ramallah. </p>
                </DocSection>
                <DocSection title="US Campaign for Palestinian Rights">
                    <p className="vfp">The USPCR focuses on ending US complicity in the ongoing colonization and genocide of Palestine. Our Tax dollars should not be funding Israel’s zionist project. Visit this <a href="https://uscpr.org/campaigns/end-u-s-military-funding-to-israel/">campaign page</a> to learn more.</p>
                </DocSection>
                <DocSection title="Gaza Soup Kitchen">
                    <p className="vfp">The <a href="https://gazasoupkitchen.com/ ">Gaza Soup Kitchen</a> was founded by a BYU alumnus Hani Almadhoun, for which he was awarded the <a href="https://kennedy.byu.edu/newsroom/distinguished-service-award-presented-to-hani-almadhoun">Distinguished Service Award.</a></p>
                </DocSection>
            </DocContent>
        </React.Fragment>
    )
}

export default VoicesForPalestine;